import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHiddenIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 35 35",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.6668 7.4263C16.2595 7.33867 16.8709 7.29167 17.5006 7.29167C24.9454 7.29167 29.8306 13.8612 31.4718 16.4599C31.6705 16.7745 31.7698 16.9317 31.8254 17.1743C31.8671 17.3565 31.8671 17.6439 31.8253 17.826C31.7697 18.0686 31.6697 18.2269 31.4696 18.5435C31.0324 19.2356 30.3657 20.2083 29.4824 21.2632M9.8063 9.79276C6.65328 11.9316 4.51274 14.9033 3.53078 16.4577C3.33125 16.7736 3.23148 16.9315 3.17587 17.174C3.1341 17.3562 3.13408 17.6436 3.17583 17.8257C3.23142 18.0683 3.33073 18.2255 3.52936 18.5401C5.17058 21.1388 10.0558 27.7083 17.5006 27.7083C20.5025 27.7083 23.0882 26.6402 25.2129 25.195M4.37561 4.375L30.6256 30.625M14.407 14.4064C13.6153 15.1981 13.1256 16.2919 13.1256 17.5C13.1256 19.9162 15.0844 21.875 17.5006 21.875C18.7087 21.875 19.8025 21.3853 20.5942 20.5936",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgHiddenIcon;
